const unknownError = (unassigned: any[]) =>
  `${unassigned.map(
    (entry: any) => `id: ${entry.id}, reason_code: ${entry.reason_code}`
  )}`;

export const parseRoutingErrors = (error: any): string => {
  const response = error?.graphQLErrors?.[0]?.extensions?.response;

  if (response) {
    switch (response.status) {
      case 422:
        return (
          parseUnprocessableEntityError(false, response.body.unassigned) ||
          unknownError(response.body.unassigned)
        );
      default:
        break;
    }
  }

  return 'Houve um erro, tente novamente mais tarde.';
};

export const parseUnprocessableEntityError = (
  isUpdateRequest: boolean,
  unassigned?: any[]
): string | undefined => {
  const routeActionLabel = isUpdateRequest === true ? 'atualizar' : 'criar';

  if (unassigned) {
    const unassignedCounted = unassignedReasonCodeCount(unassigned);

    const hasErrorCode50 = unassignedCounted.find(
      (entry: any) => entry.reason_code === 50
    );
    const hasErrorsCode50 = unassigned.find(
      (entry: any) => entry.reason_code === 50
    );
    const hasErrorCode21 = unassignedCounted.find(
      (entry: any) => entry.reason_code === 21
    );
    const hasErrorCode2 = unassignedCounted.find(
      (entry: any) => entry.reason_code === 2
    );
    const hasErrorCode3 = unassignedCounted.find(
      (entry: any) => entry.reason_code === 3
    );

    if (hasErrorCode50) {
      return reasonCode50(hasErrorCode50, hasErrorsCode50, routeActionLabel);
    }

    if (hasErrorCode21 || hasErrorCode2) {
      return 'Não foi possível criar a rota pois o tempo total de deslocamento é maior que a jornada de trabalho ou há horários de janela que não poderão ser cumpridos. Remova atividades, ajuste a jornada de trabalho ou altere as janelas de entrega.';
    }

    if (hasErrorCode3) {
      return 'Não há espaço disponível nos veículos para essa(s) atividade(s)';
    }
  }
};

const reasonCode50 = (
  error50: any,
  hasErrorsCode50: any,
  routeActionLabel: string
) => {
  if (error50.count > 1) {
    return `Não foi possível ${routeActionLabel} a rota, pois há endereços inacessíveis. Por favor, tente novamente excluindo "${hasErrorsCode50.map(
      (entry: any) => `"${entry.id}"`
    )}".`;
  }

  return `Não foi possível ${routeActionLabel} a rota, pois há um endereço inacessível. Por favor, tente novamente excluindo "${error50.id}".`;
};

const unassignedReasonCodeCount = (unassigned: any) => {
  const unassignedCount: any = {};

  unassigned.forEach((entry: any) => {
    const key = entry.reason_code;

    if (!unassignedCount[key]) {
      unassignedCount[key] = {
        ...entry,
        count: 0,
      };
    }

    unassignedCount[key].count += 1;
  });

  return Object.values(unassignedCount);
};
